<template>
	<o-tour :ref="setup._tourNewNavigation">
		<o-tour-step
			hide-finish
			:closable="false"
			title="Une navigation plus ergonomique"
			target="tour-navigation">
			<p>
				Nous avons repensé la navigation pour la rendre plus simple et plus ergonomique.
			</p>
			<p>
				Vous avez maintenant la possibilité d'ajouter des éléments à vos <strong>favoris</strong>.<br>
				Cliquer simplement sur l'étoile à droite au survol de la souris.
			</p>
		</o-tour-step>
		<o-tour-step
			hide-finish
			:closable="false"
			title=" 👤  Profil"
			target="navigation-tour-profile">
			<p>
				L'accès à votre profil s'effectue désormais depuis ce bouton.
			</p>
		</o-tour-step>
		<o-tour-step
			v-if="!setup.responsive.onPhone"
			title="Déconnexion"
			target="navigation-tour-logout">
			<p>
				Pour vous déconnecter, il suffira de cliquer ici.
			</p>
		</o-tour-step>
		<o-tour-step
			v-if="setup.responsive.onPhone"
			hide-finish
			title="Déconnexion"
			:closable="false"
			target="tour-navigation-menu"
			:next="setup.toggleMenu(true)">
			<p>Pour vous déconnecter, ouvrez d'abord le menu</p>
		</o-tour-step>

		<o-tour-step
			v-if="setup.responsive.onPhone"
			:previous="setup.toggleMenu(false)"
			title="Déconnexion"
			:end="setup.toggleMenu(false)"
			target="tour-navigation-logout-phone">
			<p>Puis cliquez sur le bouton de déconnexion</p>
		</o-tour-step>
	</o-tour>
</template>

<script setup lang="ts">
import TourNewNavigationSetupService from '@/setup/tour/TourNewNavigationSetupService';
const setup = new TourNewNavigationSetupService();
</script>

<style scoped lang="less">
</style>
